import { Routes } from "@angular/router";
import { VisitorPortalPageComponent } from "./visitors/components/visitor-portal-page/visitor-portal-page.component";
import { NotAvailablePageComponent } from "./components/not-available-page/not-available-page.component";

export const routes: Routes = [
  {
    path: "visitors/:portalUuid",
    component: VisitorPortalPageComponent,
  },
  {
    path: "not-available",
    component: NotAvailablePageComponent,
  },
  {
    path: "**",
    redirectTo: "not-available",
  },
];
